import { filterArrayEmpty } from './utils'

interface Options<T> {
  separator?: string
  filter?: (arr: Array<T>) => Array<T>
}

function arrayFilterJoin<T>(arr: Array<T>, options?: Options<T>) {
  const { separator = ' / ', filter = filterArrayEmpty } = options || {}
  return filter(arr).join(separator)
}

export default arrayFilterJoin
